import { getUserClassPath } from 'approot/classes/classes.apollo';
import IconSearch from 'approot/shared/icons/icon-search';
import { useRegionData } from 'approot/shared/region/region.apollo';
import { useMediaQuery, MEDIA_SM } from 'approot/shared/style';
import { SecondaryButton } from 'approot/shared/styles/buttons/secondary-button.style';
import { PUBLIC_HOME, PUBLIC_SEARCH } from 'global/public-routes.constants';
import HeaderLogo from '../../header/header-logo';
import {
  HeaderSecondaryActions,
  HeaderSecondarySearch,
} from '../../header/header.style';
import { LAYOUT_NAVIGATION_ID, LAYOUT_SEARCH_ID } from '../../layout.constants';
import { useLayoutLinks } from '../../layout.hooks';
import NavigationCtas from '../navigation-ctas';
import * as Styled from './navigation-header-guest.style';

type Props = {
  isActive: boolean;
  setIsActive: (value: boolean) => void;
};

const NavigationHeaderGuest = ({ isActive, setIsActive }: Props) => {
  const { goToHome } = useLayoutLinks();
  const {
    regionBanner: { height },
  } = useRegionData();

  const navCtasBreakpoint = useMediaQuery(MEDIA_SM);

  return (
    <Styled.NavHeaderGuestContainer top={height}>
      <Styled.NavHeaderGuestInner>
        <Styled.NavHeaderGuestLeft>
          <SecondaryButton
            id={LAYOUT_NAVIGATION_ID}
            aria-haspopup
            aria-expanded={isActive}
            onClick={() => setIsActive(!isActive)}
          >
            Menu
          </SecondaryButton>
          <HeaderLogo
            defaultLogoLink={getUserClassPath(PUBLIC_HOME)}
            onLogoClick={goToHome}
          />
        </Styled.NavHeaderGuestLeft>

        <HeaderSecondaryActions>
          <HeaderSecondarySearch
            to={PUBLIC_SEARCH}
            aria-label="Go to search"
            id={LAYOUT_SEARCH_ID}
            data-selector="mega-nav-search"
          >
            <IconSearch width={20} height={20} />
          </HeaderSecondarySearch>

          {navCtasBreakpoint && (
            <Styled.NavHeaderGuestRight>
              <NavigationCtas />
            </Styled.NavHeaderGuestRight>
          )}
        </HeaderSecondaryActions>
      </Styled.NavHeaderGuestInner>
    </Styled.NavHeaderGuestContainer>
  );
};

export default NavigationHeaderGuest;
